// extracted by mini-css-extract-plugin
module.exports = {"TwoDimsListFeature":"wp_a bht_b","TwoDimsListFeature__item":"wp_b bht_ux","TwoDimsListFeature__item__text":"wp_c bht_un"};